import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import FirebaseFile from "./FirebaseFile";
import ImagePage from "./ImagePage.js";
import VideoImage from "./VideoImage.js";
import Home from "./Home.js";
import SearchFile from "./SearchFile.js";
import Layout from "./Layout";
import SearchResultsPage from "./SearchResultsPage";
import Upmenu from "./Upmenu";
import FetchData from "./FetchData";
import Signup from "./Signup.js"
import Login from "./Login.js"

import "./App.css";

function ScrollAwareLayout({ children }) {
  const [showUpmenu, setShowUpmenu] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const location = useLocation();

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setShowUpmenu(true);
    } else {
      setShowUpmenu(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // When Upmenu is shown and user scrolls, remove blur after a delay
  useEffect(() => {
    if (showUpmenu) {
      setTimeout(() => {
      
      }); // Delay to show the effect of blur
    }
  }, [showUpmenu]);

  const pagesWithUpmenu = ["/", "/image", "/video", "/search-results"];
  const shouldShowUpmenu = pagesWithUpmenu.includes(location.pathname);

  return (
    <>
      {!showUpmenu && (
        <>
          <SearchFile />
          <Layout />
        </>
      )}
      {showUpmenu && shouldShowUpmenu && (
        <div
   
          style={{
            position: "fixed",
            top: 0,
           width: windowWidth < 768 ? "95%" : "100%",
            zIndex: 1000,
          
          }}
        >
          <Upmenu />
        </div>
      )}
      {children}
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/fetchdata" element={<FetchData />} />
          <Route path="/firebasefile" element={<FirebaseFile />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ScrollAwareLayout>
                <Home />
              </ScrollAwareLayout>
            }
          />
          <Route
            path="/image"
            element={
              <ScrollAwareLayout>
                <ImagePage />
              </ScrollAwareLayout>
            }
          />
          <Route
            path="/video"
            element={
              <ScrollAwareLayout>
                <VideoImage />
              </ScrollAwareLayout>
            }
          />
          <Route
            path="/search-results"
            element={
              <>
                <Upmenu/>
                <SearchResultsPage />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
